// extracted by mini-css-extract-plugin
export default {"cardButtonContainer":"OutOfTime_cardButtonContainer__2K3YN","cardHeader":"OutOfTime_cardHeader__f7w0S"};